import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'swiper/css';
import 'swiper/css/navigation';
import 'primereact/resources/themes/lara-light-cyan/theme.css';   // Theme (colors / layout skin)
import 'primereact/resources/primereact.min.css';                // Core styles (component basics)
import 'primeicons/primeicons.css';
import { HelmetProvider } from "react-helmet-async";


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
